import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ColumnPicker, ColumnOption } from './components/ColumnPicker';

/**
 * The function called from the host application to render the react component
 * @param containerId The id of the element the widget is rendered in (usually a div)
 * @param columnOptions The list of ColumnOption objects defining the available and chosen columns
 * @param onSave The callback function invoked when the Save button is clicked, it is provided the list containing both active and inactive columns
 * @param onReset The callback function to invoke when the Reset button is clicked
 * @param refCallback A callback that is invoked to provide a reference to the root component to outside code
 * @param defaultX The default X position of the ColumnPicker modal dialog
 * @param defaultY The default Y position of the ColumnPicker modal dialog
 */
export function createColumnPicker(
    containerId: string,
    columnOptions: ColumnOption[],
    onSave: (columnOptions: ColumnOption[]) => void,
    onReset: () => void,
    refCallback: (ref: ColumnPicker) => void,
    defaultX: number = 0,
    defaultY: number = 0
) {
    ReactDOM.render(
        <ColumnPicker
            columnOptions={columnOptions}
            defaultX={defaultX}
            defaultY={defaultY}
            onSave={onSave}
            onReset={onReset}
            ref={ref => refCallback(ref)}
        />,
        document.getElementById(containerId) as HTMLElement
    );
}

/**
 * Re-export the component for use in our other component projects
 */
export { ColumnPicker };
